import { render, staticRenderFns } from "./success.vue?vue&type=template&id=1cb45c06"
import script from "./success.vue?vue&type=script&lang=js"
export * from "./success.vue?vue&type=script&lang=js"
import style0 from "./success.vue?vue&type=style&index=0&id=1cb45c06&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports